import request from '@/utils/request'

let UserApi = {

  /*用户登录*/
  login(data, errorback) {
    return request._post('/shop/passport/login?appId=10001', data, errorback);
  },
  saasLogin(data, errorback) {
    return request._post('/shop/passport/saasLogin', data, errorback);
  },
  /*退出登录*/
  loginOut(data, errorback) {
    return request._post('/shop/passport/logout', data, errorback);
  },
  /*添加用户*/
  adduser(data, errorback) {
    return request._post('/shop/user/user/add', data, errorback);
  },
  /*修改用户*/
  edituser(data, errorback) {
    return request._postBody('/shop/user/user/edit', data, errorback);
  },
  /*充值*/
  userRecharge(data, errorback) {
    return request._postBody('/shop/user/user/recharge', data, errorback);
  },
  /*删除用户*/
  deleteuser(data, errorback) {
    return request._post('/shop/user/user/delete', data, errorback);
  },
  /*暂停or开启会员*/
  suspendOrOpenMemberApi(data, errorback) {
    return request._post('/shop/user/user/suspendOrOpenMember', data, errorback);
  },
  /*是否可以调整下级等级*/
  changeLevel(data, errorback) {
    return request._postBody('/shop/user/user/changeLevel', data, errorback);
  },
  /*是否允许回拨*/
  changeCallback(data, errorback) {
    return request._postBody('/shop/user/user/changeCallback', data, errorback);
  },
  /*是否可以调整划拨选项*/
  changeTransferOption(data, errorback) {
    return request._postBody('/shop/user/user/changeTransferOption', data, errorback);
  },
  /*暂停or开启出款*/
  suspendOrOpenContributeApi(data, errorback) {
    return request._post('/shop/user/user/suspendOrOpenContribute', data, errorback);
  },
  /*用户列表*/
  userlist(data, errorback) {
    return request._postBody('/shop/user/user/index', data, errorback);
  },
  /*等级列表*/
  gradelist(data, errorback) {
    return request._postBody('/shop/user/grade/index', data, errorback);
  },
  /*等级列表*/
  gradelog(data, errorback) {
    return request._postBody('/shop/user/grade/log', data, errorback);
  },
  /*添加等级*/
  addgrade(data, errorback) {
    return request._postBody('/shop/user/grade/add', data, errorback);
  },
  /*修改等级*/
  editGrade(data, errorback) {
    return request._postBody('/shop/user/grade/edit', data, errorback);
  },
  /*删除等级*/
  deletegrade(data, errorback) {
    return request._post('/shop/user/grade/delete', data, errorback);
  },
  /*用户余额*/
  BalanceLog(data, errorback) {
    return request._postBody('/shop/user/balance/log', data, errorback);
  },
  /*修改密码*/
  EditPass(data, errorback) {
    return request._post('/shop/passport/editPass', data, errorback);
  },
  /*用户标签*/
  toEditTag(data, errorback) {
    return request._get('/shop/user/user/toEditTag', data, errorback);
  },
  /*用户标签*/
  editTag(data, errorback) {
    return request._postBody('/shop/user/user/editTag', data, errorback);
  },
  /*获取等级A*/
  gradeAList(errorback) {
    return request._get('/shop/AgentGrade/AgentGrade/getList', errorback);
  },
  /*获取等级B*/
  gradeBList(errorback) {
    return request._get('/shop/AgentGrade/AgentGrade/getListPlanB', errorback);
  },
  /*wifi分佣设置*/
  userWifiSetting(data, errorback) {
    return request._postBody('/shop/user/user/userWifiSetting', data, errorback);
  },
  /*获取等级调整记录*/
  gradeLogList(data, errorback) {
    return request._get('/shop/UserAgent/UserAgent/changeChildLevelLog', data, errorback);
  },
  getUserCoupon(data, errorback) {
    return request._get('/shop/plus/coupon/coupon/getUserCoupon', data, errorback);
  },
  deleteUserCoupon(data, errorback) {
    return request._postBody('/shop/plus/coupon/coupon/deleteUserCoupon', data, errorback);
  },
}

export default UserApi;



// WEBPACK FOOTER //
// ./src/api/user.js